import { IconCompanyInformation } from '@/assets';
import { Add } from 'iconsax-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionAboutUs = () => {
  const { t } = useTranslation();
  return (
    <div className="section-about-us">
      <div className="top">
        <div className="section-about-us__left">
          <p className="label-section">[{t('About Us')}]</p>
          <IconCompanyInformation />
        </div>
        <div className="section-about-us__right">
          <p>
            {t(
              '① Warpppe is a global tech company providing innovative technology solutions based on expertise in blockchain, artificial intelligence, and web/mobile application development. Since its establishment in 2018, we have successfully completed over 200 projects across various industries including finance, investment, entertainment, and education.'
            )}
          </p>
          <p>
            {t(
              `② As a trusted partner for companies pursuing digital transformation, we provide customized technology solutions to help clients achieve their business goals and sustainable growth. Based on our rich experience in the global market and deep understanding of the latest technologies, we successfully lead our clients' digital transformation.`
            )}
          </p>
        </div>
      </div>
      <div className="icon-add">
        <Add size="40" color="#98a2b3" />
        <Add size="40" color="#98a2b3" />
      </div>
    </div>
  );
};

export default React.memo(SectionAboutUs);
